module.exports = __webpack_public_path__ + "static/media/react-native-logo.e0583d69.png";